/* Lastu: Perus? → Personoitu? -vieritysanimaatio (sections/lastu-perus-personoitu.liquid)
   Vain transform/opacity, rAF pyörii vain kun osio on näkyvissä ja vieritys liikkuu. */
(function () {
  if (window.LastuPP) return;
  // Desktop: kehä otsikon ympärillä, paikka = blokin järjestys. x vw, y vh keskeltä.
  var D = [
    { x: -31, y: -22, s: .86, z: 2, dx: -1.5, dy: -6, dr: -4, r0: 7, o: 5 },
    { x: -10.5, y: -27, s: .9, z: 3, dx: -.5, dy: -5, dr: 3, r0: -4, o: 1 },
    { x: 10.5, y: -26, s: .9, z: 3, dx: .5, dy: -6, dr: -3, r0: 5, o: 2 },
    { x: 31, y: -21, s: .86, z: 2, dx: 1.5, dy: -6, dr: 4, r0: -8, o: 6 },
    { x: -38, y: 7, s: .95, z: 4, dx: -1.5, dy: 6, dr: 4, r0: -7, o: 4 },
    { x: 38, y: 8, s: .95, z: 4, dx: 1.5, dy: 6, dr: -4, r0: 7, o: 3 },
    { x: -18.5, y: 26.5, s: .9, z: 3, dx: -.5, dy: 6, dr: -3, r0: 8, o: 7 },
    { x: 0, y: 30, s: .95, z: 5, dx: 0, dy: 5, dr: 2, r0: -2, o: 0, cta: 1 },
    { x: 18.5, y: 26.5, s: .9, z: 3, dx: .5, dy: 6, dr: 3, r0: -7, o: 8 }
  ];
  // Mobiili: 4 isoa kuorta
  var M = {
    tl: { x: -21, y: -27, s: .9, z: 3, dx: -1, dy: -4, dr: -3, r0: -6, o: 0 },
    tr: { x: 22, y: -25, s: .85, z: 2, dx: 1, dy: -5, dr: 3, r0: 7, o: 1 },
    bl: { x: -22, y: 27, s: .9, z: 2, dx: -1, dy: 5, dr: 3, r0: 6, o: 2, cta: 1 },
    br: { x: 21, y: 28, s: .88, z: 3, dx: 1, dy: 4, dr: -3, r0: -6, o: 3, cta: 1 }
  };
  var mq = window.matchMedia('(max-width: 767px)');
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)');

  function cl(v) { return v < 0 ? 0 : v > 1 ? 1 : v }
  function ramp(p, a, b) { return cl((p - a) / (b - a)) }
  function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2 }
  function eo(t) { return 1 - Math.pow(1 - t, 3) }

  function Inst(root) {
    var stage = root.querySelector('.lpp__stage');
    var W1 = root.querySelector('.lpp__w--perus'), W2 = root.querySelector('.lpp__w--pers');
    var SUB = root.querySelector('.lpp__sub'), CTA = root.querySelector('.lpp__cta');
    var phs = [].slice.call(root.querySelectorAll('.lpp__ph'));
    var els = [], vw, vh, top0, trackLen, mob;
    var target = 0, cur = null, raf = 0, lastT = 0, live = false;

    function setup() {
      mob = mq.matches; els = [];
      phs.forEach(function (el, i) {
        var c = mob ? M[el.getAttribute('data-m')] : D[+el.getAttribute('data-d')];
        if (!c) { el.style.display = 'none'; return }
        el.style.display = '';
        el.style.setProperty('--s', c.s);
        el.style.setProperty('--z', c.z + 1);
        el.style.setProperty('--fd', (6 + i % 3 * 1.3) + 's');
        el.style.setProperty('--fdl', '-' + (i * 1.7) + 's');
        // laserin maski = sama jo ladattu peruskuva (ei erillistä latausta)
        var bi = el.querySelector('.lpp__box > img'), lw = el.querySelector('.lpp__lw');
        if (!lw.style.maskImage && !lw.style.webkitMaskImage) {
          var setMask = function () { var u = 'url("' + (bi.currentSrc || bi.src) + '")'; lw.style.webkitMaskImage = u; lw.style.maskImage = u };
          if (bi.complete && bi.naturalWidth) setMask(); else bi.addEventListener('load', setMask, { once: true });
        }
        els.push({ c: c, el: el, rv: el.querySelector('.lpp__rv'), ri: el.querySelector('.lpp__rv img'),
          mat: el.querySelector('.lpp__mat'), lw: el.querySelector('.lpp__lw'), la: el.querySelector('.lpp__laser'), sh: el.querySelector('.lpp__sh'), last: '' });
      });
      measure();
    }
    function measure() {
      vw = window.innerWidth; vh = stage.offsetHeight;
      var u = mob ? Math.min(vw * .56, vh * .30) : Math.min(vw * .17, vh * .34, 300);
      root.style.setProperty('--u', u + 'px');
      top0 = root.getBoundingClientRect().top + window.pageYOffset;
      trackLen = Math.max(1, root.offsetHeight - vh);
    }
    function render(p) {
      var a1 = ramp(p, -.25, -.02) * (1 - ramp(p, .22, .30)), a2 = ramp(p, .28, .37);
      W1.style.opacity = a1;
      W1.style.transform = 'translate3d(0,' + ((1 - eo(ramp(p, -.25, -.02))) * 40 - ramp(p, .22, .30) * 30) + 'px,0)';
      W2.style.opacity = a2;
      W2.style.transform = 'translate3d(0,' + (1 - eo(a2)) * 40 + 'px,0) scale(' + (.94 + .06 * eo(a2)) + ')';
      if (SUB) { var sb = ramp(p, .34, .44); SUB.style.opacity = sb; SUB.style.transform = 'translate3d(0,' + (1 - eo(sb)) * 16 + 'px,0)' }
      var e = ramp(p, .80, .92);
      if (CTA) { CTA.style.opacity = e; CTA.style.transform = 'translate3d(0,' + (1 - eo(e)) * 20 + 'px,0)'; CTA.style.pointerEvents = e > .5 ? 'auto' : 'none' }
      var entry = p < 0 ? -p : 0;
      for (var i = 0; i < els.length; i++) {
        var o = els[i], c = o.c, depth = (c.z + 1) / 6;
        var x = c.x * vw / 100 + c.dx * vw / 100 * p;
        var y = c.y * vh / 100 + (p - .45) * c.dy * .6 * vh / 100 + entry * vh * (.35 + .5 * (1 - depth));
        var t = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) rotate(' + (c.r0 + c.dr * p).toFixed(2) + 'deg)';
        if (t !== o.last) { o.el.style.transform = t; o.last = t }
        var st = .36 + c.o * (mob ? .045 : .03), rv = ease(ramp(p, st, st + .14));
        // hover-tila (CSS): is-off = ei vielä kaiverrusta, is-on = kaiverrus valmis
        var hs = rv <= 0 ? 'is-off' : rv >= 1 ? 'is-on' : '';
        if (hs !== o.hs) { if (o.hs) o.rv.classList.remove(o.hs); if (hs) o.rv.classList.add(hs); o.hs = hs }
        if (rv <= 0) { o.rv.style.visibility = 'hidden'; o.lw.style.opacity = 0 }
        else {
          o.rv.style.visibility = 'visible';
          o.rv.style.transform = 'translate3d(0,' + (-(1 - rv) * 100).toFixed(2) + '%,0)';
          o.ri.style.transform = 'translate3d(0,' + ((1 - rv) * 100).toFixed(2) + '%,0)';
          o.lw.style.opacity = rv >= 1 ? 0 : Math.min(1, Math.sin(Math.PI * rv) * 1.6);
          o.la.style.transform = 'translate3d(0,' + (rv * 100).toFixed(2) + '%,0)';
        }
        // nappien kohdalle osuvat materiaalitekstit väistyvät nappien tieltä
        if (o.mat && c.cta) o.mat.style.opacity = 1 - ramp(p, .74, .84);
        o.sh.style.transform = 'scale(' + (1 - .12 * Math.sin(p * 3 + i)) + ')';
      }
    }
    function readTarget() { target = Math.max(-.6, Math.min(1, (window.pageYOffset - top0) / trackLen)) }
    function tick(t) {
      var dt = lastT ? Math.min(64, t - lastT) : 16; lastT = t;
      if (cur === null) cur = target;
      cur += (target - cur) * (1 - Math.exp(-dt / 90));
      if (Math.abs(target - cur) < .0004) cur = target;
      render(cur);
      raf = cur !== target ? requestAnimationFrame(tick) : 0;
      if (!raf) lastT = 0;
    }
    function kick() { readTarget(); if (!raf) raf = requestAnimationFrame(tick) }

    root.classList.add('is-js');
    if (rm.matches) { root.classList.add('is-rm'); setup(); render(1); return }
    setup(); readTarget(); cur = target; render(cur);

    var io = new IntersectionObserver(function (en) {
      live = en[0].isIntersecting; root.classList.toggle('is-live', live);
      if (live) { measure(); kick() }
    }, { rootMargin: '50% 0px' });
    io.observe(root);
    window.addEventListener('scroll', function () { if (live) kick() }, { passive: true });
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { if (mob !== mq.matches) setup(); else measure(); kick() }, 120);
    });
    // sivun yläpuolinen sisältö voi muuttaa korkeuttaan (kuvat, appit) → mittaa uudelleen
    if (window.ResizeObserver) new ResizeObserver(function () { measure(); if (live) kick() }).observe(document.body);
  }

  function initAll(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-lpp]:not([data-lpp-ok])'), function (r) {
      r.setAttribute('data-lpp-ok', ''); Inst(r);
    });
  }
  window.LastuPP = { init: initAll };
  initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target) });
})();
